<script>
import con from '@services/connection'
import { servicos } from '@constants/URL'
import Title from '@components/section-title'
import Vue from 'vue'
import { toMoney, getNumber, toTitleCase } from '@utils/Format'
import store from '@state/store'
import moment from 'moment'
import { GlobalBus } from '@services/bus'
import { funcaoIndisponivel } from '@utils/Whitelabel'
import { MODAL } from '@constants/Text'
import { copyToClipboard } from '@utils/Clipboard'
import ModalIndicacao from '@modal/modal-indicacao'

import { customSort } from '@utils/Sort'

export default {
  components: {
    Title,
    ModalIndicacao,
  },
  props: {
    bus: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isWhitelabel: WHITELABEL,
      busModal: new Vue(),
      loading: false,
      servico: {},
      dados: {},
      searchClient: '',
      selectedsClients: [],
      tab: null,
      headers: [
        {
          text: 'Nome',
          align: 'left',
          value: 'nome_cliente',
        },
        {
          text: 'Email',
          value: 'email',
        },
        {
          text: 'Data de contratação',
          value: 'data_contratacao',
        },
        {
          text: 'Receita',
          value: 'valor_profissional',
        },
        // {
        //   text: '',
        //   value: 'action',
        //   sortable: false,
        // },
      ],
      getNumber: getNumber,
      toMoney: toMoney,
      toTitleCase: toTitleCase,
      moment: moment,
      link_adesao: '',
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
  },
  created() {
    GlobalBus.$on(MODAL.SEE_MORE_SERVICE, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.SEE_MORE_SERVICE, this.open)
  },
  methods: {
    open(s) {
      this.clearData()

      if (typeof s === 'object') {
        this.servico = s
        this.load(s)
      } else {
        this.load(s)
      }

      if (typeof s === 'string') {
        this.getService(s)
      }

      this.busModal.$emit('dialog', !!s)
    },
    clearData() {
      this.loading = false
      this.servico = {}
      this.dados = {}
      this.searchClient = ''
      this.selectedsClients = []
      this.tab = null
    },
    formatMoney(v) {
      return toMoney(v)
    },
    openSendLink() {
      this.bus.$emit(MODAL.SEND_LINK, this.servico)
    },
    async getService(code) {
      const data = {
        codigo_servico: code,
      }
      const r = await con.post(servicos.cliente.get, data)
      if (r.status === 200 && r.value) {
        this.servico = r.value
      }
    },
    async load(servico) {
      if (this.loading) {
        return
      }
      this.loading = true
      const data = {}
      if (typeof servico === 'object') {
        data['codigo_servico'] = servico.codigo_servico || ''
        data['id_servico'] = servico.id_servico || ''
      } else {
        data['codigo_servico'] = isNaN(servico) ? servico : ''
        data['id_servico'] = isNaN(servico) ? '' : servico
      }
      const r = await con.post(servicos.profissional.get_data, data) // '/mirror'
      if (r.status === 200) {
        this.dados = r.value
      }
      this.generateLinkAdesao()
      if (this.dados.contratados && this.dados.contratados.length) {
        this.dados.contratados.forEach((v) => {
          v.data_contratacao = moment(v.data_contratacao).format('DD/MM/YYYY')
          v.valor_profissional = toMoney(v.valor_profissional)
          v.email = v.email.toLowerCase()
        })
      }
      if (
        this.dados.historico_pagamentos &&
        this.dados.historico_pagamentos.length
      ) {
        this.dados.historico_pagamentos.forEach((v) => {
          v.email = v.email.toLowerCase()
          v.valor_profissional = toMoney(v.valor_profissional)
          v.nome_cliente = toTitleCase(v.nome_cliente)
          v.data_registro_contratacao = moment(
            v.data_registro_contratacao
          ).format('DD/MM/YYYY')
        })
      }
      this.dados.receita_total = this.dados.receita_total
        ? toMoney(this.dados.receita_total)
        : '-'
      this.loading = false
    },
    sendComunicate() {
      if (this.selectedsClients && this.selectedsClients.length) {
        GlobalBus.$emit(MODAL.SEND_COMUNICATE, {
          clientes: this.selectedsClients,
        })
      } else {
        this.$showSnack({
          text: 'Selecione pelo menos um cliente',
          button: true,
        })
      }
    },
    openClient(c) {
      if (c.id) {
        store.dispatch('user/addSearchClient', {
          id: c.id || '',
          id_cadastro_cliente: c.id_cadastro_cliente || '',
          name: c.nome_cliente || '',
        })
        this.$router.push({ name: 'carteira' })
      }
    },
    async generateLinkAdesao() {
      const data = {
        ids_servicos: JSON.stringify([this.servico.id_servico]),
      }
      const r = await con.post(servicos.generate_link_adesao, data)
      if (r.status === 200) {
        this.link_adesao = r.value.url_link
      }
    },
    copyClipboard(input) {
      copyToClipboard(this.$refs[input].$refs.input, this)
    },
    openIndicacao() {
      if (!this.isWhitelabel) {
        this.funcWhitelabel()
        return
      }
      this.bus.$emit(MODAL.INDICACAO, this.servico)
    },
    funcWhitelabel() {
      funcaoIndisponivel(this)
    },
    customSort(a, b, c) {
      const dict = {
        texts: ['nome_cliente', 'email'],
        dates: ['data_contratacao'],
        numbers: ['valor_profissional'],
      }
      return customSort(a, b, c, dict)
    },
    goToContrato() {
      if (this.$route.name != 'contrato') {
        this.$router.push({ name: 'contrato' })
      }
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900px">
    <Title :title="servico.nome_servico || 'Serviço'" />
    <v-row v-if="loading" justify="center" align="center">
      <div class="text-center ma-12 w-100">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-row>
    <div v-else>
      <v-row>
        <v-col>
          <div>
            <p style="margin-bottom: 0px">
              Descrição:
            </p>
            <small class="text-secondary">{{
              servico.descricao_servico
            }}</small>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div>
            <p style="margin-bottom: 0px">
              Taxa:
            </p>
            <small class="text-secondary">{{ servico.taxa }}</small>
          </div>
        </v-col>
        <v-col>
          <div>
            <p style="margin-bottom: 0px">
              Receita Total:
            </p>
            <small class="text-success">
              <strong> {{ dados.receita_total }} </strong>
            </small>
          </div>
        </v-col>
        <v-col>
          <div>
            <p style="margin-bottom: 0px">
              Proximo mês:
            </p>
            <small class="text-success">
              <strong> {{ dados.receita_prox_mes }} </strong>
            </small>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4">
          <div>
            <p style="margin-bottom: 0px">
              Qtd clientes:
            </p>
            <small class="text-secondary">
              {{ dados.contratados ? dados.contratados.length : '-' }}
            </small>
          </div>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            ref="linkAdesao"
            v-model="link_adesao"
            readonly
            label="Enviar link do serviço (sem comissão)"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="copyClipboard('linkAdesao')">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </template>
                <span>Copiar link</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <div>
        <v-tabs v-model="tab">
          <v-tab key="clientes"> Clientes </v-tab>
          <v-tab v-if="!servico.free" key="historico">
            Histórico de pagamentos
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item key="clientes">
            <v-data-table
              v-if="dados.contratados"
              v-model="selectedsClients"
              :headers="headers"
              :items="dados.contratados"
              show-select
              height="220"
              item-key="login"
              :search="searchClient"
              fixed-header
              :custom-sort="customSort"
            >
              <template v-slot:item.nome_cliente="{ item }">
                <td>
                  <v-row style="align-items: center;">
                    <v-icon
                      v-if="!item.id_cadastro_cliente"
                      small
                      right
                      color="primary"
                    >
                      mdi-account
                    </v-icon>
                    <v-icon v-else small right>
                      mdi-account-switch
                    </v-icon>
                    <p style="margin-bottom: 0px; margin-left: 5px">
                      {{ item.nome_cliente }}
                    </p>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.action="{ item }">
                <v-btn text icon small @click="selectedClients(item)">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <p class="pt-3">Nenhum cliente encontrado</p>
                <BaseButton
                  v-if="$canSendLinks"
                  primary
                  small
                  @click="openSendLink"
                >
                  Enviar link
                </BaseButton>
              </template>
            </v-data-table>
            <p v-else style="padding: 20px;">
              Este serviço ainda não possui contratações.
            </p>
          </v-tab-item>

          <v-tab-item key="historico">
            <v-simple-table
              v-if="dados.historico_pagamentos"
              fixed-header
              height="250"
              class="table-ativos"
            >
              <template v-slot>
                <thead>
                  <th class="text-left border-right" style="max-width: 300px">
                    Nome
                  </th>
                  <th class="border-right">E-mail</th>
                  <th colspan="2" class="border-right">Valor</th>
                  <th class="border-right">
                    Data de pagamento
                  </th>
                </thead>
                <tbody>
                  <tr
                    v-for="(v, i) in dados.historico_pagamentos"
                    :key="`key-${i}`"
                  >
                    <td
                      class="text-left border-right"
                      style="max-width: 300px; cursor: pointer"
                      @click="openClient(v)"
                    >
                      <div>
                        <strong>
                          {{ v.nome_cliente }}
                        </strong>
                      </div>
                    </td>
                    <td class="border-right">
                      {{ v.email }}
                    </td>
                    <td colspan="2" class="border-right">
                      {{ v.valor_profissional }}
                    </td>
                    <td class="border-right">
                      {{ v.data_registro_contratacao }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <p v-else style="padding: 20px;">
              Este serviço não possui pagamentos
            </p>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Fechar
      </BaseButton>
      <BaseButton
        v-if="servico.permite_indicacao"
        primary
        @click="openIndicacao"
      >
        Indicar serviço
      </BaseButton>
      <BaseButton primary @click="sendComunicate">
        Enviar comunicado
      </BaseButton>
      <v-spacer />
    </template>
    <ModalIndicacao :bus="bus" />
  </BaseModal>
</template>

<style lang="sass" scope>
table.table-ativos
  thead
    & + tbody
      tr
        &:first-child
          td
            padding-top: 17px

  th
    padding-left: 10px
    padding-right: 10px

  td
    padding-left: 10px
    padding-right: 10px

  tbody tr:hover
    background-color: var(--gray-3) !important
</style>
